// extracted by mini-css-extract-plugin
export default {"logo-uni":"LogoUni_logo-uni__WkOKN","logo":"LogoUni_logo__Nelql","hidden":"LogoUni_hidden__sfKFa"};